import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Services from './views/Services.vue'
import DoctorNote from './views/DoctorNote.vue'
import Media from './views/Media.vue'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: (route) => ({ query: route.query.lang })
    },
    {
      path: '/services',
      name: 'services',
      component: Services,
      props: (route) => ({ query: route.query.lang })
    },
    {
      path: '/doctornote',
      name: 'doctornote',
      component: DoctorNote,
      props: (route) => ({ query: route.query.lang })
    },
    {
      path: '/media',
      name: 'media',
      component: Media,
      props: (route) => ({ query: route.query.lang })
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})
